
import { Link } from 'react-router-dom';
import PageHero from '../../../components/base/PageHero';

export default function ResourcesHeroSection() {
  return (
    <PageHero
      breadcrumb="Resources"
      label="Learning Hub"
      title="Resources to Support Your Training Journey"
      description="Access guides, compliance templates, programme catalogues, and expert resources to maximise your training investment and stay ahead of SETA requirements."
    >
      <Link to="/contact"><button className="btn btn-white">Schedule Consultation <i className="ri-arrow-right-line ml-2" /></button></Link>
    </PageHero>
  );
}
